/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Method_Cod_Via_CarrierInputs */

const vi_cashflow_method_cod_via_carrier = /** @type {(inputs: Cashflow_Method_Cod_Via_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`COD qua hãng vận chuyển`)
};

/**

* @param {Cashflow_Method_Cod_Via_CarrierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_method_cod_via_carrier = /** @type {((inputs?: Cashflow_Method_Cod_Via_CarrierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Method_Cod_Via_CarrierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_method_cod_via_carrier(inputs)
});